import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	pack: 0,
}

export const planesSlice = createSlice({
	name: "planes",
	initialState,
	reducers: {
		setPack: (state, action) => {
			state.pack = action.payload
		},
	}
});

export const { setPack, loadingEnd } = planesSlice.actions;
export default planesSlice.reducer;